import Vue from 'vue'
import { MutationTree } from 'vuex'
import { mealTypes } from './types'
import { MealState } from './state'
import { MealCountStatus, MealCountDto, SaveMealCountRequest, MergeServingLineRequest } from '@/models'
import { mcCounts } from '@/utils'
import { Guid } from 'guid-typescript'

export const mealMutations: MutationTree<MealState> = {
  [mealTypes.mutations.updateCountDto](state: MealState, dto: MealCountDto) {
    if (dto) {
      const mealCountsIndex = state.mealCountDtos.findIndex(m => mcCounts.matchMealCountKey(m, dto));

      // Set the trackingGuid for records that don't have them.
      // Records that get downloaded from server have empty tracking guids.
      if (dto.trackingId === Guid.EMPTY) {
        const guid = Guid.create().toString();
        dto.trackingId = guid;
        dto.trackingGuid = guid;
      }

      const index = mealCountsIndex > -1 ? mealCountsIndex : state.mealCountDtos.length;
      Vue.set(state.mealCountDtos, index, dto);
    }
  },

  [mealTypes.mutations.updateTempDto](state: MealState, mealCounts: MealCountDto) {
    state.tempDto = mealCounts.mealTypeId ? [...state.tempDto.filter(m => !mcCounts.matchMealCountKey(m, mealCounts)), mealCounts] : [];
  },

  [mealTypes.mutations.updateRequestToSyncUp](state: MealState, request: SaveMealCountRequest) {
    let index = state.syncUpCounts.findIndex(m => mcCounts.matchMealCountKey(m.version, request.version));
    index = index > -1 ? index : state.syncUpCounts.length;
    Vue.set(state.syncUpCounts, index, request);
  },

  [mealTypes.mutations.clearSyncUp](state: MealState) {
    state.syncUpCounts = [];
  },

  [mealTypes.mutations.updateCountStatus](state: MealState, countStatus: MealCountStatus) {
    if (countStatus) {
      const mealCountsIndex = state.mealCountStatuses.findIndex(m => mcCounts.matchCountStatuses(m, countStatus));

      const index = mealCountsIndex > -1 ? mealCountsIndex : state.mealCountStatuses.length;
      Vue.set(state.mealCountStatuses, index, countStatus);
    }
  },

  [mealTypes.mutations.updateSyncDate](state: MealState, syncDate) {
    state.lastSyncUtc = syncDate;
  },

  [mealTypes.mutations.updateMergeServingLines](state: MealState, request: MergeServingLineRequest) {
    let existing = state.mergeServingLines.find(o => o.VersionTrackingId === request.VersionTrackingId);

    if (!existing) {
      state.mergeServingLines = [...state.mergeServingLines, request];
    }
    else {
      request.MergeLines.forEach(ml => {
        let line = existing?.MergeLines.find(o => o.servingLineTrackingId === ml.servingLineTrackingId);
        if(line) {
          line.mergedIntoLineTrackingId = ml.servingLineTrackingId;
          line.discarded = ml.discarded;
          line.mergedDateTimeUtc = ml.mergedDateTimeUtc;
        }
        else {
          existing?.MergeLines.push(ml);
        }
      });
    }
  },

  [mealTypes.mutations.clearServingLines](state: MealState) {
    state.mergeServingLines = [];
  }
};
